import createCache from "@emotion/cache";
import { CacheProvider } from "@emotion/react";
import ReactDOM from "react-dom/client";
import type { FC } from "react";
import { injectBaseStyles } from "@/utils/widget-runtime";

const PlaygroundComponent: FC = () => {
  return <></>;
};

class PlaygroundWebComponent extends HTMLElement {
  private root: ReactDOM.Root | null = null;

  constructor() {
    super();
    this.attachShadow({ mode: "open" });
  }

  connectedCallback() {
    // Inject base styles including system fonts
    injectBaseStyles(this);

    const cache = createCache({
      key: "shadow-emotion",
      container: this.shadowRoot as unknown as Element,
    });

    this.root = ReactDOM.createRoot(this.shadowRoot as ShadowRoot);
    this.root.render(
      <CacheProvider value={cache}>
        <PlaygroundComponent />
      </CacheProvider>,
    );
  }

  disconnectedCallback() {
    if (this.root) {
      this.root.unmount();
      this.root = null;
    }
  }
}

export default PlaygroundWebComponent;
